/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useEffect } from 'react'
import htmr from 'htmr'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { useResendEmailMutation, useViewEmailLogsQuery } from 'api/account'
import { useAppSelector } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function ViewEmailLightbox({ status, close }: Props) {
    const { emailLog: { id, subject, parseDate } } = useAppSelector((state) => state.account)
    const { data, isFetching } = useViewEmailLogsQuery(+id, { skip: !id })
    const [resendEmail, { isLoading, isSuccess }] = useResendEmailMutation()

    useEffect(() => {
        if (isSuccess) close()
    }, [isSuccess])

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={subject}
            description={parseDate}
            loading={isFetching}
            content={<>{htmr(data?.message ? data.message : '')}</>}
            conditions={{ state: status, action: () => close() }}
            links={[]}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    func: () => close()
                },
                {
                    label: 'Resend',
                    color: 'primary',
                    loading: isLoading ? 'Sending' : false,
                    func: () => resendEmail(id)
                }
            ]}
        />
    )
}
